import React from 'react';
import TimeDisplay from './TimeDisplay';
import { Button } from '../ui/button';
import { useIsMobile } from '../../hooks/use-mobile';

const SectionHeader = ({ 
  icon, 
  title,
  secondaryTitle,
  description,
  showTimeToggle = false,
  onTimeChange 
}) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 md:mb-4 gap-1 md:gap-2">
      <div className="flex items-center gap-1 md:gap-2">
        <div className="text-[#6366F1]">
          {icon}
        </div>
        <div>
          <h2 className="text-base md:text-xl font-bold">{title}</h2>
          {secondaryTitle && (
            <p className="text-xs md:text-sm font-medium text-gray-600">{secondaryTitle}</p>
          )}
          {description && (
            <p className="text-[10px] md:text-sm text-gray-500">{description}</p>
          )}
        </div>
      </div>
      {showTimeToggle && (
        <div className="flex items-center overflow-x-auto pb-1 md:pb-0 gap-0.5 md:gap-2 mt-1 md:mt-0">
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => onTimeChange?.('24h')}
            className="text-[10px] md:text-xs px-1.5 md:px-3 h-6 md:h-8"
          >
            24h
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => onTimeChange?.('7d')}
            className="text-[10px] md:text-xs px-1.5 md:px-3 h-6 md:h-8"
          >
            7d
          </Button>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => onTimeChange?.('30d')}
            className="text-[10px] md:text-xs px-1.5 md:px-3 h-6 md:h-8"
          >
            30d
          </Button>
          <TimeDisplay lastUpdated="24 hours" />
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
